import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	blockedBy: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.blocked-by',
		defaultMessage: 'blocked by',
		description:
			'Separator line label. Appears on the line between blocker and blocked issues in dependency tooltip.',
	},
	blocks: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.blocks',
		defaultMessage: 'blocks',
		description:
			'Separator line label. Appears on the line between blocked issue and blocker in dependency tooltip.',
	},
	dependencyOf: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.dependency-of',
		defaultMessage: 'Dependency of <b>{itemKey} {title}</b>',
		description: 'Dependency of label. Appears on the top of the dependency tooltip.',
	},
	datesOverlapWarning: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.dates-overlap-warning',
		defaultMessage: 'Dates overlap',
		description:
			'Warning message text. Appears when a dependency due date is greater, that a target issue start date.',
	},
	warningsText: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.warnings-text',
		defaultMessage: 'Warnings',
		description: 'Warning message text. Appears when a issue has some warnings',
	},
	issueWithStartDateLabel: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.issue-with-start-date-label',
		defaultMessage: '{issueType} {issueTitle} starts on {issueDate}',
		description:
			'Label for issue, where {issueType} is the type of issue, {issueTitle} is the title of the issue and {issueDate} is start date',
	},
	issueWithDueDateLabel: {
		id: 'roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.issue-with-due-date-label',
		defaultMessage: '{issueType} {issueTitle} ends on {issueDate}',
		description:
			'Label for issue, where {issueType} is the type of issue, {issueTitle} is the title of the issue and {issueDate} is due date',
	},
});
